module.exports = __webpack_public_path__ + "media/images/main_post_sp-77f04b0236d9d65265ebc02a847feed2.png";